import { Plan } from "@/types/auxiliarAuth";

// All database functions are hardcoded mock implementations

export async function getSuggestionsAndRecommendations(id: string): Promise<any> {
  // Return mock script data
  return {
    id: id,
    general_analysis: { title: "Mock Script" },
    synopsis: "A mock synopsis",
  };
}

export async function getScenesByScriptId(scriptId: string) {
  // Return empty mock scenes
  return [];
}

export async function getCharactersByScriptId(scriptId: string) {
  // Return empty mock characters
  return [];
}

// Insert Script Analysis Data - Mock
export async function insertScriptAnalysis(data: any, userId: string) {
  // Return a mock ID instead of inserting into database
  const mockId = "mock-script-" + Math.random().toString(36).substr(2, 9);
  console.log("Mock insertScriptAnalysis - ID:", mockId);
  return mockId;
}

// Insert Full Script Data - Mock
export async function insertFullScript(scriptId: string, data: any) {
  console.log("Mock insertFullScript - scriptId:", scriptId);
  return;
}

// Insert Character Data - Mock
export async function insertCharacters(scriptId: string, characterArcs: any[]) {
  console.log("Mock insertCharacters - scriptId:", scriptId);
  return;
}

export async function changePlanSubscription(plan: string, userId: string){
  const proPlanId = process.env.STRIPE_PRO_PLAN_ID as string;
  const teamPlanId = process.env.STRIPE_PREMIUM_PLAN_ID as string;

  let newSubscription: Plan | null = null;

  console.log("Mock changePlanSubscription - User ID:", userId);
  console.log("Mock changePlanSubscription - Plan ID:", plan);

  switch(plan){
    case proPlanId:
      newSubscription = Plan.PRO;
      break;
    case teamPlanId:
      newSubscription = Plan.PREMIUM;
      break;
    default:
      newSubscription = Plan.FREE;
      break;
  }

  console.log("Mock changePlanSubscription - New Subscription:", newSubscription);
  return { message: "Subscription updated successfully (mock)", newSubscription };
}

export async function getUserSubscription(userId: string) {
  // Always return premium subscription
  console.log("Mock getUserSubscription - User ID:", userId);
  return "premium";
}

export async function updateScriptUser(userId: string, scriptId: string) {
  // Return mock data
  console.log("Mock updateScriptUser - userId:", userId, "scriptId:", scriptId);
  return { id: scriptId, id_user: userId };
}

export async function getCharacterIdsByScriptId(scriptId: string) {
  // Return empty array
  console.log("Mock getCharacterIdsByScriptId - scriptId:", scriptId);
  return [];
}
